import axios from 'axios';

export default class RestResource {
  login(creds) {
    return axios.post('users/login.php', creds);
  }
  getAllUsers() {
    return axios.get('users/getAll.php');
  }
  getUsersByParent(userId) {
    return axios.post('users/getUsersByParent.php', {
      ParentID: userId
    });
  }
  getAllActions() {
    return axios.get('actions/getAll.php');
  }
  getUsersActionsByParent(userId) {
    return axios.post('users/getUsersActionsByParent.php', {
      ParentID: userId
    });
  }
  getUserActions(userId) {
    return axios.post('users/getActions.php', {
      UserID: userId
    });
  }
  getUser(userId) {
    return axios.post('users/getByID.php', {
      UserID: userId
    });
  }
  deleteUserById(userId) {
    return axios.post('users/delete.php', {
      UserID: userId
    });
  }
  saveUser(user) {
    if (user.UserID) {
      return axios.post('users/edit.php', user);
    } else {
      return axios.post('users/add.php', user);
    }
  }
  addUser(user) {
    return axios.post('users/add.php', user);
  }
  updateUser(user) {
    return axios.post('users/edit.php', user);
  }
  getAction(actionId) {
    return axios.post('actions/getByID.php', {
      ActionID: actionId
    });
  }
  addAction(action) {
    return axios.post('actions/add.php', action);
  }
  updateAction(action) {
    return axios.post('actions/edit.php', action);
  }
  deleteActionById(actionId) {
    return axios.post('actions/delete.php', {
      ActionID: actionId
    });
  }
  getDropdown(dropdownGroup) {
    return axios.post('dropdowns/getByGroup.php', {
      DropDownGroup: dropdownGroup
    });
  }
  getNotificationById(notificationId) {
    return axios.post('notifications/getByID.php', {
      NotificationID: notificationId
    });
  }
  deleteNotificationById(notificationId) {
    return axios.post('notifications/delete.php', {
      NotificationID: notificationId
    });
  }
  getNotificationsByActionId(actionId) {
    return axios.post('notifications/getByActionID.php', {
      ActionID: actionId
    });
  }
  saveNotification(notification) {
    if (notification.NotificationID) {
      return axios.post('notifications/edit.php', notification);
    } else {
      return axios.post('notifications/add.php', notification);
    }
  }
  test(userId) {
    return axios.post('users/testID.php', {
      UserID: userId
    });
  }
}